import { type Reservation } from 'webReservations/reservations/apiHelpers';

type MinimalReservationInfoNeededToDeriveIntel = Pick<
  Reservation,
  'wasTableChosenAtTimeOfBooking' | 'listing'
>;

export const reservationTableDisplayName = ({
  wasTableChosenAtTimeOfBooking,
  listing,
}: MinimalReservationInfoNeededToDeriveIntel): null | string => {
  if (!wasTableChosenAtTimeOfBooking || !listing?.publicName) {
    return null;
  }

  return listing.publicName;
};
